const previewCls = "_uihpi418bz";
const imageCls = "_uihizsac53";
const iconCls = "_uihiq0ytvb";
const contentWrapperCls = "_uihc1vvm9fk";
const textCls = "_uihtfbxtey";

export { contentWrapperCls, iconCls, imageCls, previewCls, textCls };
import "./atom.preview.style.linaria.module.css";
//# sourceMappingURL=atom.preview.style.js.map
